import angular from 'angular';

angular
    .module('envelope')

    .factory('EnvelopeService', [
        '$resource',
        'API_CONFIG',
        function($resource, API_CONFIG) {
            var Envelope = $resource(
                API_CONFIG.url + '/v1/envelope/:envelopeId',
                { envelopeId: '@id' },
                {
                    // Recherche suivant les critères
                    searchByCriterias: {
                        url: API_CONFIG.url + '/v1/envelope/searchByCriterias',
                        method: 'POST',
                        isArray: true
                    },
                    // Vérifie si au moins une des enveloppes envoyés a besoin d'un traitement spécific
                    containsSpecificTreatment: {
                        url: API_CONFIG.url + '/v1/envelope/containsSpecificTreatment',
                        method: 'POST',
                        isArray: true
                    },
                    // Vérifie si des lots associés aux envelopes sont en cours de traitement ou terminé
                    containsBatchBeingOrAlreadyTreated: {
                        url: API_CONFIG.url + '/v1/envelope/containsBatchBeingOrAlreadyTreated',
                        method: 'POST',
                        isArray: true
                    },
                    // Reprend des plis
                    resumption: {
                        url: API_CONFIG.url + '/v1/envelope/resumption',
                        method: 'POST'
                    },
                    resumptionFirstShipment: {
                        url: API_CONFIG.url + '/v1/envelope/resumption-first-shipment',
                        method: 'POST'
                    },
                    // Affecte des plis au statut ID_TEMP à un container
                    affectContainer: {
                        url: API_CONFIG.url + '/v1/envelope/match-evl-container',
                        method: 'POST'
                    },
                    // Met les plis en erreur
                    rejectEnvelope: {
                        url: API_CONFIG.url + '/v1/envelope/reject-envelope',
                        method: 'POST'
                    },
                    // Récupération de la liste des plis au statut en attente de confirmation par rapport à une liste de deposants.
                    findWaitingConfirmByDepositors: {
                        url: API_CONFIG.url + '/v1/envelope/find-waitingconfirm-by-depositors',
                        method: 'POST',
                        isArray: true
                    }
                }
            );

            return Envelope;
        }
    ]);
